import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetReplenishment = (params) => {
    return async (dispatch, getState) => {
        try {
            params.search = params.search.replace(/\s/g, '');
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_LIST_REPLENISHMENT
            });
            if (data.status === 'success') {
                const getArrayMap = (value) => {
                    const tmp = [];
                    if (value.length) {
                        for (let i = 0; i < value.length; i++) {
                            if ((i < value.length - 1) && +value[i].event_date === +value[i + 1].event_date) {
                                tmp.push([{ ...value[i] }, { ...value[i + 1] }])
                                i++;
                            } else {
                                tmp.push(value[i])
                            }
                        }
                    }
                    return tmp
                }
                dispatch(Action.SetGetReplenishmentAction({
                    data: getArrayMap(data.data),
                    countPage: data.countPage
                }));
                dispatch(Action.SetLoadingAction(false))
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetReplenishment as SetGetReplenishment
}